import { render } from "./CollectionDailyReportTable.vue?vue&type=template&id=07121a0b"
import script from "./CollectionDailyReportTable.vue?vue&type=script&lang=js"
export * from "./CollectionDailyReportTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__